<template>
  <div class="page-content_">
    <vk-offcanvas flipped overlay stuck :show.sync="showTableOffCanvas">
      <div style="width: auto !important; overflow: scroll">
        <vk-offcanvas-close
          @click="showTableOffCanvas = false"
        ></vk-offcanvas-close>
        <h3>Report</h3>
        <hr />
        <!-- {{JSON.stringify(exportDataTableoptions)}} -->
        <template style="overflow: scroll">
          <el-select
            v-model="exportDataToTableValuesFields"
            multiple
            placeholder="Select"
          >
            <el-option
              v-for="item in exportDataTableoptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </template>
        <div>
          <div class="overflow-auto">
            <b-table
              responsive
              :items="exportDataToTableValues"
              :fields="exportDataToTableValuesFields"
              :per-page="perPage"
              :current-page="currentPage"
              small
            ></b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
            ></b-pagination>

            <p class="mt-3">Current Page: {{ currentPage }}</p>
          </div>
        </div>
      </div>
    </vk-offcanvas>
    <div v-if="initError" class="sadFaceIOT">
      <!-- {{graphDeviceDetails}} -->
      <i class="fa fa-meh-o fa-3x" style="font-size: 20rem"></i>
      <h1>Device not smart yet!!!</h1>
      <h3>check back later...</h3>
    </div>

    <div v-else class="col-md-12">
      <!-- {{Device}} -->
      <div
        class="widget widget-alpha widget-alpha--color-amaranth"
        style="flex-flow: row; display: flex"
      >
        <div class="stats" style="align-items: left; padding: 10px">
          <h1 class="stats_header__title">
            Device
            {{
              Device.parameters && statusCalc(Device.parameters.TimeStamp)
                ? "Offline"
                : "Online"
            }}
          </h1>
          <b style="font-size: 21px">Last Seen: {{ lastSeen() }}</b>

          <p style="margin-top: 20px">
            <img src="@/assets/img/avatar.png" alt class="_user-avatar" />
            {{ installationData.name || "-" }}
          </p>
        </div>
        <div
          style="
            display: flex;
            padding: 10px !important;
            flex-flow: row;
            justify-content: flex-end;
          "
        >
          <can I="manage" a="user">
            <button
              class="btn btn-danger"
              v-if="
                Device.parameters && statusCalc(Device.parameters.TimeStamp)
              "
              @click="triggerRemoveDeviceOnPerformanceList()"
            >
              Remove
            </button>
            &nbsp;
          </can>
          <span
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <button
              class="btn btn-outline-warning"
              v-if="errorCalc(deviceWarning) == 'warning'"
              @click="showWAlarm('warnings')"
            >
              Warning
            </button>
            <button
              class="btn btn-outline-danger"
              v-if="errorCalc(deviceWarning) == 'error'"
              @click="showWAlarm('error')"
            >
              Fault
            </button>
          </span>
        </div>
      </div>
      <div v-if="screenView.code === 0">
        <div class="stats" style="align-items: left; padding: 10px"></div>

        <div class="row">
          <div class="col-md-12" v-if="errorCalc(deviceWarning) == 'error'">
            <b-alert show variant="danger">
              <i
                class="fa fa-exclamation-triangle icon-right input-icon error-icon"
              ></i>
              <ul>
                <li
                  v-for="(key, index_error) in flags.faults"
                  v-show="deviceWarning[index_error] == 1"
                  :key="`${index_error}_error`"
                >
                  {{ key }}
                </li>
              </ul>
            </b-alert>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
            <div class="row" style="margin-bottom: 12px">
              <div class>
                <el-collapse
                  class="page-content"
                  v-model="activeNames"
                  @change="handleChange"
                >
                  <el-collapse-item title="Monitor" name="1">
                    <system-monitor
                      :isDeviceOffline="statusCalc(Device.parameters.TimeStamp)"
                      :device="Device"
                    />
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
                <div
                  class="widget widget-alpha widget-alpha--color-amaranth"
                  style="height: 90%"
                >
                  <div class="top-widget-box performance">
                    <div class="top-widget-box__header">
                      <i class="fa fa-calendar fa-4x icon"></i>
                    </div>
                    <div class="top-widget-box__body">
                      <span class="stats_header__title">Device Status</span>
                      <h1>
                        {{
                          Device.parameters &&
                          statusCalc(Device.parameters.TimeStamp)
                            ? "Offline"
                            : "Online"
                        }}
                      </h1>
                      <p class="top-subtitle">Last Seen: {{ lastSeen() }}</p>
                      <p class="stats_header__title">&nbsp;</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
                <div
                  class="widget widget-alpha widget-alpha--color-amaranth"
                  style="height: 90%"
                >
                  <div class="top-widget-box performance">
                    <div class="top-widget-box__header">
                      <i class="fa fa-bolt fa-4x icon"></i>
                    </div>
                    <div class="top-widget-box__body">
                      <span class="stats_header__title">Load active power</span>
                      <h1>{{ activePower(Device.parameters) }}</h1>
                      <p class="top-subtitle">
                        <!-- {{Device.parameters}} -->
                        {{ Number(Device.parameters.OutputLoadPercent) }}% Load
                      </p>
                      <p class="stats_header__title">&nbsp;</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
                <div
                  class="widget widget-alpha widget-alpha--color-amaranth"
                  style="height: 90%"
                >
                  <div class="top-widget-box performance">
                    <div class="top-widget-box__header">
                      <battery
                        :width="`60px`"
                        :height="`40px`"
                        :direction="`y`"
                        :level="Device.parameters.BatteryCapacity"
                      ></battery>
                    </div>
                    <div class="top-widget-box__body">
                      <span class="stats_header__title">Battery status</span>
                      <h1>{{ Device.parameters.BatteryCapacity * 1 }}%</h1>
                      <p class="top-subtitle">{{ batteryMode(Device.mode) }}</p>
                      <p class="stats_header__title">
                        PV Power:
                        {{
                          Device.parameters
                            ? panelPower(Device.parameters)
                            : "-"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
                <div
                  class="widget widget-alpha widget-alpha--color-amaranth"
                  :style="{
                    'background-color':
                      parseFloat(MiscData.GridPower) > 0
                        ? '#2ED47A !important'
                        : '#e74c3c !important',
                    height: '100%'
                  }"
                >
                  <div class="top-widget-box performance">
                    <div class="top-widget-box__header">
                      <i
                        class="fa fa-lightbulb-o fa-4x icon"
                        aria-hidden="true"
                        style="color: #fff"
                      ></i>
                    </div>
                    <div class="top-widget-box__body">
                      <span class="stats_header__title" style="color: #fff"
                        >Grid Status</span
                      >
                      <h1 style="color: #fff">
                        {{ parseFloat(MiscData.GridPower) > 0 ? "ON" : "OFF" }}
                      </h1>
                      <p class="top-subtitle">&nbsp;</p>
                      <p class="stats_header__title">&nbsp;</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Energy data and co -->
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div
              class="widget widget-alpha widget-alpha--color-amaranth"
              style="flex-flow: column"
            >
              <div class="row stat_data_row">
                <div class="col-sm-4 power_stat_">
                  <div
                    class="fa fa-bolt fa-4x text-center"
                    style="color: rgb(61, 177, 53)"
                  ></div>
                  <h3 class="stats-title">Generated Energy</h3>
                </div>
                <div class="col-sm-8 power_stat_row_" style="font-size: 12px">
                  <div style="margin: 5px">
                    <div class="stats_header__title text-left">Today</div>
                    <div class>
                      {{
                        confirmEnergy(Device.parameters.EnergyData)
                          .GeneratedToday || 0 * 1
                      }}kWh
                    </div>
                  </div>
                  <div style="margin: 5px">
                    <div class="stats_header__title text-left">This Week</div>
                    <div class>
                      {{
                        confirmEnergy(Device.parameters.EnergyData)
                          .GeneratedWeek || 0 * 1
                      }}kWh
                    </div>
                  </div>
                  <div style="margin: 5px">
                    <div class="stats_header__title text-left">This Month</div>
                    <div class>
                      {{
                        confirmEnergy(Device.parameters.EnergyData)
                          .GeneratedMonth || 0 * 1
                      }}kWh
                    </div>
                  </div>
                  <div style="margin: 5px">
                    <div class="stats_header__title text-left">This Year</div>
                    <div class>
                      {{
                        confirmEnergy(Device.parameters.EnergyData)
                          .GeneratedYear || 0 * 1
                      }}kWh
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="widget widget-alpha widget-alpha--color-amaranth"
              style="flex-flow: column"
            >
              <div class="row stat_data_row">
                <div class="col-sm-4 power_stat_">
                  <div
                    class="fa fa-bolt fa-4x text-center"
                    style="color: rgb(232, 150, 0)"
                  ></div>
                  <h3 class="stats-title">Consumed Off Grid</h3>
                </div>
                <div class="col-sm-8 power_stat_row_" style="font-size: 12px">
                  <div style="margin: 5px">
                    <div class="text-left stats_header__title">Today:</div>
                    <div class>
                      {{
                        confirmEnergy(Device.parameters.EnergyData)
                          .ConsumedTodayOffGrid || 0 * 1
                      }}kWh
                    </div>
                  </div>
                  <div style="margin: 5px">
                    <div class="text-left stats_header__title">This Week:</div>
                    <div class>
                      {{
                        confirmEnergy(Device.parameters.EnergyData)
                          .ConsumedWeekOffGrid || 0 * 1
                      }}kWh
                    </div>
                  </div>
                  <div style="margin: 5px">
                    <div class="text-left stats_header__title">This Month:</div>
                    <div class>
                      {{
                        confirmEnergy(Device.parameters.EnergyData)
                          .ConsumedMonthOffGrid || 0 * 1
                      }}kWh
                    </div>
                  </div>
                  <div style="margin: 5px">
                    <div class="text-left stats_header__title">This Year:</div>
                    <div class>
                      {{
                        confirmEnergy(Device.parameters.EnergyData)
                          .ConsumedYearOffGrid || 0 * 1
                      }}kWh
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <can I="read" a="all">
              <div
                class="widget widget-alpha widget-alpha--color-amaranth"
                style="flex-flow: column"
              >
                <div class="row stat_data_row">
                  <div class="col-sm-4 power_stat_">
                    <div
                      class="fa fa-bolt fa-4x text-center"
                      style="color: rgb(235, 59, 124)"
                    ></div>
                    <h3 class="stats-title">Energy Consumed On Grid</h3>
                  </div>
                  <div class="col-sm-8 power_stat_row_" style="font-size: 12px">
                    <div style="margin: 5px">
                      <div class="text-left stats_header__title">Today:</div>
                      <div class>
                        {{
                          confirmEnergy(Device.parameters.EnergyData)
                            .ConsumedTodayOnGrid || 0 * 1
                        }}kWh
                      </div>
                    </div>
                    <div style="margin: 5px">
                      <div class="text-left stats_header__title">
                        This Week:
                      </div>
                      <div class>
                        {{
                          confirmEnergy(Device.parameters.EnergyData)
                            .ConsumedWeekOnGrid || 0 * 1
                        }}kWh
                      </div>
                    </div>
                    <div style="margin: 5px">
                      <div class="text-left stats_header__title">
                        This Month:
                      </div>
                      <div class>
                        {{
                          confirmEnergy(Device.parameters.EnergyData)
                            .ConsumedMonthOnGrid || 0 * 1
                        }}kWh
                      </div>
                    </div>
                    <div style="margin: 5px">
                      <div class="text-left stats_header__title">
                        This Year:
                      </div>
                      <div class>
                        {{
                          confirmEnergy(Device.parameters.EnergyData)
                            .ConsumedYearOnGrid || 0 * 1
                        }}kWh
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </can>

            <div
              class="widget widget-alpha widget-alpha--color-amaranth"
              style="flex-flow: column"
            >
              <div class="row stat_data_row">
                <div class="col-sm-4 power_stat_">
                  <div
                    class="fa fa-bolt fa-4x text-center"
                    style="color: rgb(235, 59, 124); transform: rotate(20%)"
                  ></div>
                  <h3 class="stats-title text-center">Peak Power Generated</h3>
                </div>
                <div class="col-sm-8 power_stat_row_" style="font-size: 12px">
                  <div style="margin: 5px">
                    <div class="text-left stats_header__title">Today:</div>
                    <div class>
                      {{
                        confirmEnergy(Device.parameters.EnergyData).PeakToday ||
                          0 * 1
                      }}kWp
                    </div>
                  </div>
                  <div style="margin: 5px">
                    <div class="text-left stats_header__title">This Week:</div>
                    <div class>
                      {{
                        confirmEnergy(Device.parameters.EnergyData).PeakWeek ||
                          0 * 1
                      }}kWp
                    </div>
                  </div>
                  <div style="margin: 5px">
                    <div class="text-left stats_header__title">This Month:</div>
                    <div class>
                      {{
                        confirmEnergy(Device.parameters.EnergyData).PeakMonth ||
                          0 * 1
                      }}kWp
                    </div>
                  </div>
                  <div style="margin: 5px">
                    <div class="text-left stats_header__title">This Year:</div>
                    <div class>
                      {{
                        confirmEnergy(Device.parameters.EnergyData).PeakYear ||
                          0 * 1
                      }}kWp
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Energy data and co end -->

          <!-- uncomment -->
          <!-- <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
          <div class="col-md-6 col-sm-6 col-xs-12">
            <el-card class="box-card widget">
              <div
                slot="header"
                class="widget_header"
                style="display: flex;  justify-content: space-between;"
              >
                <span class="widget_header__title" style="flex: 1;">Battery/Load Chart</span>
              </div>
              <grey-chart :type="charttype" :data="chartdata" :id="`healthchart`" ref="healthchart"></grey-chart>
            </el-card>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <el-card class="box-card widget">
              <div
                slot="header"
                class="widget_header"
                style="display: flex; justify-content: space-between;"
              >
                <span class="widget_header__title" style="flex: 1;">Generation/Consumption Chart</span>
              </div>
              <grey-chart
                :type="charttype"
                :data="solarchartdata"
                :id="`solarchartdata`"
                ref="solarchartdata"
              ></grey-chart>
            </el-card>
          </div>
          </div>-->
        </div>
      </div>

      <div
        v-if="screenView.code === 2"
        class="box-card widget control-power-stats col-md-12 col-sm-12 col-xs-12 mb-5"
      >
        <device-control :inverterId="inverterId"></device-control>
      </div>
      <!-- <div
        v-if="screenView.code === 1"
        class="box-card widget col-md-12 col-sm-12 col-xs-12 mb-5"
      >
        <device-charts :inverterId="inverterId"></device-charts>
      </div> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import {
  Carousel,
  CarouselItem,
  Breadcrumb,
  Loading,
  DatePicker,
  BreadcrumbItem,
  Notification
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import GreyChart from "@/components/pages/kitchen/grey-chart";
import InstallationStat from "../installationStat";
import dummyData from "../dummy.json";
import Battery from "@/components/pages/kitchen/grey-battery";
import moment from "moment";
import { HTTP as IOTHTTP } from "@/store/actions";
// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";
import { mapGetters, mapActions } from "vuex";
// const endies =
//   "http://arnergyiot-dev.88se6pd53y.us-west-2.elasticbeanstalk.com/";
// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { clearTimeout, clearInterval } from "timers";
var flatten = require("flat");
// var converter = require("json-2-csv");
import DeviceControl from "../widgets/controls";
import DeviceCharts from "../widgets/charts";

Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(DatePicker);
Vue.use(Loading);

let liveTimeout = null;

import SystemMonitor from "@/components/pages/dashboard/animated-icons";

export default {
  name: "deviceDetails",
  props: {
    inverterId: {
      default: null
    },
    screenView: {
      type: Object,
      default: "Mad"
    }
  },
  components: {
    InstallationStat,
    GreyChart,
    Battery,
    datetime: Datetime,
    "device-control": DeviceControl,
    "device-charts": DeviceCharts,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "system-monitor": SystemMonitor
    // powerStat,
    // flatPickr,
  },
  computed: {
    ...mapGetters(["DeviceList", "graphDeviceDetails"]),
    rows() {
      return this.exportDataToTableValues.length;
    },
    statusBorder: {
      get() {
        return "4px solid #e34a4a;";
      },
      set(nvalue) {
        this.statusBorderHandle = nvalue;
      }
    }
    // Device: {
    //   get() {
    //     var inverterId = this.inverterId;
    //     return {
    //       parameters: this.DeviceList.devices.find(
    //         x => x.DeviceID == inverterId
    //       ),
    //       mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
    //       expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
    //     };
    //   }
    // }
  },
  beforeDestroy: function() {
    // console.log("teardown shii", liveTimeout);
    // clearTimeout(liveTimeout);
    this.liveTimeout.destroy();
  },
  data: function() {
    return {
      activeNames: ["1"],
      loading: true,
      filterDate: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      liveTimeout: null,
      initError: false,
      installationData: {
        name: "Loding..."
      },
      deviceWarning: {},
      powerState: {},
      chargerPriority: "01",
      showTableOffCanvas: false,
      perPage: 10,
      currentPage: 1,
      exportDataToTableValues: [],
      exportDataTableoptions: [],
      exportDataToTableValuesFields: [
        "payload.TimeStamp",
        "payload.PVInputVoltage",
        "payload.InverterId",
        "payload.EnergyData.ConsumedYearOffGrid"
      ],
      // [00, 01, 02] (utility first, solar first, solar and utility)
      chargerPriorityList: [
        {
          text: "Select Option",
          value: null,
          disabled: true
        },
        {
          text: "Utility First",
          value: "00"
        },
        {
          text: "Solar First",
          value: "01"
        },
        {
          text: "Solar and Utility",
          value: "02"
        }
      ],
      outputPriority: "01",
      outputPriorityList: [
        {
          text: "Select Option",
          value: null,
          disabled: true
        },
        {
          text: "Utility First",
          value: "00"
        },
        {
          text: "Solar First",
          value: "01"
        },
        {
          text: "SBU First",
          value: "02"
        }
      ],
      deviceMode: "00",
      deviceModeList: [
        {
          text: "Select Option",
          value: null,
          disabled: true
        },
        {
          text: "Inverter Mode",
          value: "00"
        },
        {
          text: "UPS Mode",
          value: "01"
        }
      ],
      show: true,
      Device: {},
      // IOTSRC: "https://arnergy-dash-api.herokuapp.com",
      IOTSRC: "http://arnergy-dash-api.herokuapp.com",
      expiryToSend: "",
      THIS_WEEK: moment()
        .startOf("week")
        .toDate(),
      THIS_MONTH: moment()
        .startOf("month")
        .toDate(),
      isMale: true,
      statusBorderHandle: "red",
      charttype: "line",
      showWarning: false,
      chartdata: {
        labels: ["Please", "wait", ".", ".", ".", "."],
        datasets: [
          {
            label: "Loading",
            data: [],
            backgroundColor: "rgba(255, 99, 132, 0.3)",
            borderWidth: 1
          }
        ]
      },
      solarchartdata: {
        labels: ["Please", "wait", ".", ".", "."],
        datasets: [
          {
            label: "Loading",
            data: [],
            backgroundColor: "rgba(255, 99, 132, 0.3)",
            borderWidth: 1
          }
        ]
      },
      timeRightNow: moment(),
      endpointsMap: {
        "on-power": "power",

        "off-power": "power",

        "get-expiry": "requestexpdate",

        "set-expiry": "expirydate",

        "pcp-charger-priority": "charger-priority",

        "pop-output-priority": "output-priority",

        "pgr-device-mode": "device-mode",

        "open-ssh": "ssh",

        "command-shell": "shell",

        "send-command": "command",

        "init-reboot": "reboot",

        "get-settings": "setting",

        "init-reset": "reset",

        "get-batteql": "battequal",

        "on-admin": "admin",

        "off-admin": "admin"
      },
      pickerConfig: {
        enableTime: true,
        dateFormat: "F j, Y",
        // dateFormat: "H-i-S-d-m-Y",
        wrap: true
      },
      commandSending: "",
      ipAddress: "",
      username: "",
      password: "",
      expiryDate_: null,
      currentCommand: "",
      currentParam: "",
      details: "/device/details",
      HealthData: [],
      warnings: [],
      battery_meter: {
        background: "green",
        width: "50%"
      },
      flags: {
        faults: {
          InverterFault: "Inverter Fault",
          BusOver: "Bus Overload",
          BusUnder: "Bus Underload",
          BusSoftFail: "Bus Failed",
          InverterVoltageTooLow: "Inverter Voltage Too Low",
          InverterVoltageTooHigh: "Inverter Voltage Too High",
          InverterOverCurrent: "Inverter Overcurrent",
          InverterSoftFail: "Inverter failed (soft)",
          SelfTestFail: "Self test failed",
          OPDCVoltageOpen: "",
          BatteryOpen: "Battery Open",
          CurrentSensorFail: "Current Sensor failed"
        },
        warnings: {
          // LineFail: "Line Failed",
          OPVShort: "Pv Output Short Circuit",
          BatteryUnderShutdown: "Battery Under Shortdown",
          EepromFault: "EEPROM Fault",
          BatteryLowAlarm: "Battery Low",
          PVLoss: "No supply from PV",
          BatteryDerating: "Battery Derating"
        }
      }
    };
  },
  methods: {
    ...mapActions(["refreshList", "performanceGraphCall"]),
    triggerRemoveDeviceOnPerformanceList() {
      let response = confirm("Are you sure you want to continue?");
      if (response) {
        // alert(JSON.stringify("Removing in progress =>") + this.inverterId);

        var headers = {
          "Content-Type": "application/plain"
        };
        let params = {
          TableName: "ConnectedDevices",
          Key: {
            DeviceID: parseInt(this.inverterId)
          }
        };
        IOTHTTP.post(`/devicedata/delete`, params, {
          headers
        })
          .then(resp => {
            alert("Successfully removed");
            this.$router.go(-1);

            // this.$router.go(-1);
          })
          .catch(err => {
            alert("An error uccured please try agin");
            console.log(err);
          });
      }
    },
    filterChart() {
      console.log(this.filterDate);
      this.loading = true;
      this.filterDate
        ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000)
        : this.getDeviceData();
    },
    showWAlarm(type) {
      let resp = Object.keys(this.flags[type]).reduce((_tmp, _curr) => {
        return (_tmp +=
          this.deviceWarning[_curr] == 1
            ? `<li>${this.flags[type][_curr]}</li>`
            : "");
      }, "");
      Notification.warning({
        title: `${type[0].toUpperCase()}${type.slice(1)}`,
        dangerouslyUseHTMLString: true,
        message: resp
      });
      // console.log({
      //   deviceWarning: this.deviceWarning,
      //   flags: this.flags.warnings,
      //   resp
      // });
    },
    errorCalc(Payload) {
      var excluded = [
          "id",
          "deviceID",
          "TimeStamp",
          "TimeStamp",
          "updatedAt",
          "lineFail"
        ],
        tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (
          Payload.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0
        ) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              return "warning";
            } else if (this.flags.faults[property]) {
              return "error";
            }
          }
        }
      }
      return;
    },
    exportData() {
      this.filterDate
        ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000)
        : this.DataToExport();
    },
    exportDataToTable() {
      this.filterDate
        ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000)
        : this.DataToExportToTable();
    },
    async DataToExportToTable(
      upperLimit = null,
      lowerLimit = null,
      limit = 100
    ) {
      this.timeRightNow = await this.currentTime();
      let container = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      let data = {
        TableName: "Parameters",
        KeyConditionExpression:
          "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
        ExpressionAttributeValues: {
          ":key": `${inverterId}`,
          ":up":
            upperLimit ||
            moment("2019/6/20")
              .startOf("day")
              .toDate(),
          ":down": lowerLimit || new Date().toISOString()
        },
        Limit: limit,
        ScanIndexForward: false
      };
      // console.log(data);
      IOTHTTP.post(`/devicedata`, data, {
        headers
      }).then(resp => {
        this.showTableOffCanvas = true;
        var exportedData = resp.data.Items.map(data => {
          return flatten(data);
        });
        console.log(exportedData);
        if (exportedData.length > 0) {
          let temp = Object.keys(exportedData[0]);
          console.log(temp);

          this.exportDataTableoptions = Object.keys(exportedData[0]);
        }
        this.exportDataToTableValues = exportedData;
        let json2csvCallback = function(err, csv) {
          if (err) throw err;
          //return csv;
          var hiddenElement = document.createElement("a");
          hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
          hiddenElement.target = "_blank";
          hiddenElement.download = "reports.csv";
          hiddenElement.click();
        };
        // converter.json2csv(exportedData, json2csvCallback);
      });
    },
    async DataToExport(upperLimit = null, lowerLimit = null, limit = 100) {
      this.timeRightNow = await this.currentTime();
      let container = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      let data = {
        TableName: "Parameters",
        KeyConditionExpression:
          "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
        ExpressionAttributeValues: {
          ":key": `${inverterId}`,
          ":up":
            upperLimit ||
            moment("2019/6/20")
              .startOf("day")
              .toDate(),
          ":down": lowerLimit || new Date().toISOString()
        },
        Limit: limit,
        ScanIndexForward: false
      };
      // console.log(data);
      IOTHTTP.post(`/devicedata`, data, {
        headers
      }).then(resp => {
        var exportedData = resp.data.Items.map(data => {
          return flatten(data);
        });

        this.exportDataToTableValues = exportedData;
        let json2csvCallback = function(err, csv) {
          if (err) throw err;
          //return csv;
          var hiddenElement = document.createElement("a");
          hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
          hiddenElement.target = "_blank";
          hiddenElement.download = "reports.csv";
          hiddenElement.click();
        };
        // converter.json2csv(exportedData, json2csvCallback);
      });
    },
    async currentTime() {
      const me = this;
      const HTTP = this.$httpUtils.instance;
      let response = await HTTP.get(
        "https://arnergy.com/weather-api/time/?" + Date.now()
      );
      let tmpDate = response.data.datetime.split(".")[0];
      return tmpDate;
    },
    datePickerTrigger() {
      this.show = true;
    },
    formatDate(_date) {
      // return _date;
      return moment(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    lastSeen() {
      // console.log(this.Device);
      return this.Device.parameters
        ? new Date(this.Device.parameters.TimeStamp).toDateString() +
            " " +
            new Date(this.Device.parameters.TimeStamp).toLocaleTimeString()
        : "--";
      // return this.Device.parameters.DeviceTimeStamp;
    },
    getError(key, type) {
      var search = this.flags[type];
      if (this.Device.warnings[key] > 0) {
        return search[key];
      }
    },
    // statusCalc(date) {
    //   return this.statusCalc(this.Device.parameters.DeviceTimeStamp) == true
    //     ? "4px solid #e34a4a;"
    //     : "4px solid #1893CA;";
    // },
    statusCalc(date) {
      var difference = Math.abs(moment(this.timeRightNow).diff(moment(date)));
      // console.log(difference / 60000);
      if (difference / 60000 > 90) {
        this.statusBorder = "4px solid #e34a4a";
        return true;
      } else {
        this.statusBorder = "4px solid #1893CA";
        return false;
      }
    },
    statusLabel(date) {
      var difference = Math.abs(moment().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    batUpdate(charge) {
      this.battery_meter.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg =
          "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg =
          "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg =
          "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
    },
    roundUp(num) {
      return Math.round(num * 100) / 100;
    },
    Parse_Json(data) {
      return JSON.parse(data);
    },
    countFlags(Warning, type) {
      var excluded = [
        "id",
        "deviceID",
        "DeviceTimeStamp",
        "createdAt",
        "updatedAt"
      ];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (
          Warning.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0 &&
          search.hasOwnProperty(property)
        ) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    batteryMode(mode) {
      var resp = "Battery Mode";
      switch (mode) {
        case "P":
          resp = "Power On";
          break;
        case "S":
          resp = "On Standby";
          break;
        case "L":
          resp = "On Grid";
          break;
        case "B":
          resp = "On Battery";
          break;
        case "F":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
          resp = "Charging";
          break;
        default:
      }
      return resp;
    },
    renderChart() {},
    timeAgo(date) {
      var difference = moment(date).fromNow();
      return difference;
    },
    activePower(parameters) {
      var power = this.roundUp((parameters.ACOutputActivePower * 1) / 1000);
      return power + "kW";
    },
    panelPower(parameters) {
      var power = this.roundUp((parameters.PVChargingPower * 1) / 1000);
      return power + " kW";
      // var power = this.roundUp(
      //   (parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1)) / 1000
      // );
      // return power + " kW";
    },
    powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    confirmEnergy(data) {
      if (data == undefined) return [];
      return data;
    },
    async graphDetailsCall(cid) {
      // 416813
      if (!cid) {
        return true;
      }
      const FastAPIHTTP = this.$httpUtils.FastAPIHTTP;
      await FastAPIHTTP.get(`/devices/${cid}`)
        .then(res => {
          console.log("---> V2 <----");

          console.log(res);
          console.log("++++++++>=1", this.Device);
          if (res.data.data.device["Items"]) {
            this.Device = {
              ...this.Device,
              parameters: res.data.data.device["Items"][0]["payload"]
            };
            console.log("++++++++>=2", this.Device);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    async fetchAllDeviceData() {
      this.timeRightNow = await this.currentTime();
      let container = this;
      var headers = {
        "Content-Type": "application/plain"
      };
      let payLoad = {
        ":key": Number(this.inverterId)
      };
      let data = {
        TableName: "ConnectedDevices",
        FilterExpression: `DeviceID IN (${Object.keys(payLoad).toString()})`,
        ExpressionAttributeValues: payLoad
        // Limit: limit,
        // ScanIndexForward: false
      };
      IOTHTTP.post(`/devicedata/scan`, data, {
        headers
      })
        .then(resp => {
          if (resp.data["Items"]) {
            this.Device = {
              ...this.Device,
              parameters: resp.data["Items"][0]
            };
            console.log("++++++++>=", this.Device);
          }
          // this.liveTimeout = setTimeout(this.fetchAllDeviceData, 60000);
          // console.log("++++++++>=",  resp.data['Items']);
        })
        .catch(err => {
          //  console.log("=++++++++>", err);
          // this.liveTimeout = setTimeout(this.fetchAllDeviceData, 60000);
        });
    },
    fetchHealth(type) {
      const container = this;
      const HTTP = this.$httpUtils.instance;
      HTTP.get(`${this.IOTSRC}/health/${this.inverterId}/${type}?`)
        .then(response => {
          var respTime = [];
          var Chartdata = response.data;
          var temptime = Chartdata["Time"];
          temptime.forEach(element => {
            respTime.push(moment(element).format("Do MMM hh:mm"));
          });
          container.chartdata = {
            labels: respTime.reverse(),
            datasets: [
              {
                label: "Battery Voltage",
                backgroundColor: "rgba(255, 99, 132, 0.2)",
                data: Chartdata["BatteryVoltage"].reverse()
              },
              {
                label: "PV Charging Power",
                backgroundColor: "rgba(54, 162, 235, 0.2)",
                data: Chartdata["PVChargingPower"].reverse()
              },
              {
                label: "Battery Charging Current",
                backgroundColor: "rgba(255, 206, 86, 0.2)",
                data: Chartdata["BatteryChargingCurrent"].reverse()
              },
              {
                label: "Battery Capacity",
                backgroundColor: "rgba(75, 192, 192, 0.2)",
                data: Chartdata["BatteryCapacity"].reverse()
              },
              {
                label: "Output Load Percent",
                backgroundColor: "rgba(153, 102, 255, 0.2)",
                data: Chartdata["OutputLoadPercent"].reverse()
              },
              {
                label: "Grid Voltage",
                backgroundColor: "rgba(255, 153, 0, 0.6)",
                data: Chartdata["GridVoltage"].reverse()
              },
              {
                label: "AC Output ActivePower",
                backgroundColor: "rgba(255, 159, 64, 0.2)",
                data: Chartdata["ACOutputActivePower"].reverse()
              }
            ]
          };
          container.charttype = "line";
          container.renderChart();
        })
        .catch(e => {
          //  console.log(e);
        });
    },
    expiryDate(deviceID) {
      const deviceExpiry = this.findDeviceData(
        this.DeviceList.expiries,
        "DeviceID",
        deviceID
      );

      return deviceExpiry !== undefined
        ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"])
        : "--";
    },
    findDeviceData(dataset, key, value) {
      const res = dataset.filter(x => x[key] == value);
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    async initFetch() {
      let { deviceId } = this.$route.params;
      // let timeRightNow = await this.currentTime();
      // this.performanceGraphCall(timeRightNow);
      var inverterId = this.inverterId * 1;
      // console.log(
      //   "============================",

      // );
      this.graphDetailsCall(parseInt(deviceId));
      let data_tmp = this.DeviceList.find(x => x.DeviceID == inverterId);
      console.log("===========", data_tmp.payload);
      this.Device = {
        ...data_tmp,
        parameters: data_tmp.payload
        //   mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
        //   expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
      };
      // console.log(",,,,,", this.Device);
      if (this.Device.parameters == null) {
        this.initError = true;
      }
    },
    getDeviceState() {
      let container = this;
      var inverterId = this.inverterId;
      var FASTHTTP = this.$httpUtils.FastAPIHTTP;
      FASTHTTP.get(`/devicestate/${inverterId}`)
        .then(resp => {
          // console.log(resp.data.state.reported.userPower);
          if (resp.data.state.reported.userPower) {
            container.powerState = resp.data.state.reported.userPower;
          }
        })
        .catch(err => {
          //console.log(err)
        });
    },
    transformData(data, keys) {
      return data.reduce(
        (aggr, c_item) => {
          keys.map(key => {
            aggr[key] = [...aggr[key], c_item["payload"][key] * 1];
          });
          return aggr;
        },
        keys.reduce((ret, crr) => {
          ret[crr] = [];
          return ret;
        }, {})
      );
    },
    getTimeLabel(data) {
      return data.reduce((aggr, c_item) => {
        aggr = [
          ...aggr,
          moment(c_item["payload"]["TimeStamp"])
            .add(1, "hour")
            .format("MMM d YYYY - h:m:s A")
        ];
        return aggr;
      });
    },
    solarDataChart(displayData, labels) {
      let Chartdata = this.transformData(displayData, [
        "ACOutputActivePower",
        "PVChargingPower"
      ]);
      this.solarchartdata = {
        labels: labels,
        datasets: [
          {
            pointRadius: 0,
            label: "Output Active Power",
            borderColor: "#109cf1",
            backgroundColor: "rgba(16, 156, 241,0.4)",
            data: Chartdata["ACOutputActivePower"]
          },
          {
            pointRadius: 0,
            label: "PV Charging Power",
            borderColor: "#ffb946",
            // backgroundColor: "rgba(0,0,0,0.3)",
            backgroundColor: "rgba(255, 185, 70,0.8)",
            data: Chartdata["PVChargingPower"]
          }
        ]
      };
      this.charttype = "line";
      this.loading = false;
      // this.renderChart();
      this.$refs.solarchartdata.reload(this.solarchartdata, this.charttype);
    },
    batteryChart(displayData, labels) {
      let Chartdata = this.transformData(displayData, [
        "BatteryCapacity",
        "OutputLoadPercent"
      ]);
      this.chartdata = {
        labels: labels,
        datasets: [
          {
            pointRadius: 0,
            label: "Battery Percent",
            borderColor: "#109cf1",
            backgroundColor: "rgba(16, 156, 241,0.4)",
            data: Chartdata["BatteryCapacity"]
          },
          {
            pointRadius: 0,
            label: "Load Percent",
            borderColor: "#ffb946",
            backgroundColor: "rgba(255, 185, 70,0.8)",
            data: Chartdata["OutputLoadPercent"]
          }
        ]
      };
      this.charttype = "line";
      // this.renderChart();
      this.$refs.healthchart.reload(this.chartdata, this.charttype);
    },
    getDeviceData(upperLimit = null, lowerLimit = null, limit = 100) {
      let container = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      let data = {
        TableName: "Parameters",
        KeyConditionExpression:
          "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
        ExpressionAttributeValues: {
          ":key": `${inverterId}`,
          ":up":
            upperLimit ||
            moment("2019/6/20")
              .startOf("day")
              .toDate(),
          ":down": lowerLimit || new Date().toISOString()
        },
        Limit: limit,
        ScanIndexForward: false
      };
      // console.log(data);
      IOTHTTP.post(`/devicedata`, data, {
        headers
      })
        .then(resp => {
          let DevData = resp.data.Items;
          //  console.log(DevData);
          // console.log(this.getTimeLabel(DevData));
          this.batteryChart(DevData, this.getTimeLabel(DevData));
          this.solarDataChart(DevData, this.getTimeLabel(DevData));
          // console.log(resp.data.state.reported.userPower);
          // if (resp.data.state.reported.userPower) {
          //   container.powerState = resp.data.state.reported.userPower;
          // }
        })
        .catch(err => {
          //  console.log(err)
        });
    },
    getDeviceWarnings() {
      let app = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      let data = {
        TableName: "Warnings",
        KeyConditionExpression:
          "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": moment().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      IOTHTTP.post(`/devicedata`, data, {
        headers
      })
        .then(resp => {
          let DevData = resp.data.Items;
          //  console.log(DevData);
          if (DevData[0]) {
            app.deviceWarning = DevData[0]["payload"];
          }
          // console.log(this.getTimeLabel(DevData))
          // this.batteryChart(DevData, this.getTimeLabel(DevData));
          // this.solarDataChart(DevData, this.getTimeLabel(DevData));
          // console.log(resp.data.state.reported.userPower);
          // if (resp.data.state.reported.userPower) {
          //   container.powerState = resp.data.state.reported.userPower;
          // }
        })
        .catch(err => {});
    },
    getDevice() {
      //  console.log(err)

      var inverterId = this.inverterId;
      const context = this;
      const HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      const url = `/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][or][0][CID]=${inverterId}&filter[where][or][1][solarKitIds]=${inverterId}`;
      HTTP.get(url)
        .then(response => {
          //  console.log({ response });
          if (response.data.length > 0)
            context.installationData = response.data[0];
        })
        .catch(error => {
          return "not assign";
          //console.log("error", error);
        });
    }
  },
  created() {},
  async mounted() {
    this.initError = false;
    try {
      // await this.currentTime();
      this.initFetch().then(x => {
        // console.log(this.DeviceList);
        // this.initFetch();
        this.getDevice();
        this.getDeviceState();
        this.getDeviceWarnings();
        // this.fetchAllDeviceData();

        let { deviceId } = this.$route.params;
        console.log(deviceId);
        this.graphDetailsCall(parseInt(deviceId));
      });
    } catch (error) {
      this.initError = true;
      //  console.log("Init Error", error);
    }

    // this.fetchHealth("today");
    // this.statusBorder = "4px solid #000";
    //
  }
};
</script>

<style lang="scss" scoped>
ul {
  margin-top: 0px !important;
}

.info-div-inner .stats {
  flex-flow: column;
}

address {
  small {
    color: #9b9b9b;
    font-size: 0.75rem;
  }
}

.sm-font-size {
  font-size: 13px;
  margin-left: 13px;
}

.d-flex button {
  width: 100%;
}

button,
.vuestic-switch {
  margin-bottom: 1rem;
}

button,
button i {
  font-size: 0.7em;
}

.btn.btn-with-icon i {
  font-size: 1.5em;
}

.flatpickr-next-month,
.flatpickr-next-month.flatpickr-next-month {
  right: 0 !important;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.dash_details {
  background: #1a93ca;
  padding: 8px 15px;
  color: #ffffff;
  width: 100%;
  border-radius: 4px 4px 0px 0px;
}

.stats_header__title {
  font-size: 15px;
  color: #a2b5c5;
  font-weight: 600;
  letter-spacing: 0.13px;
}

._user-avatar {
  height: 48px;
  width: 48px;
  border-radius: 50%;
}

.power_stat_ {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.power_stat_row_ {
  display: flex;
  flex-flow: row;
  text-align: left;
  justify-content: space-between;
}

.stat_data_row {
  display: flex;
  justify-content: center;
  width: 100%;
}

@media (max-width: 1399px) {
  .col-xl-3.col-lg-3.col-md-6 {
    width: 50% !important;
  }
}

.top-subtitle {
  font-size: 1rem !important;
}

.sadFaceIOT {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column nowrap;
  min-height: calc(100vh - 250px);
  color: #9b9b9b;
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/detailsV2/v2.vue